import { colors } from "../config/colors.mjs";
const spaceTokens = {
    "callout.gap": 16,
    "callout.iconContainer.padding": 4,
    "callout.padding": 16
  },
  radiusTokens = {
    "callout.default": 8
  },
  colorTokens = {
    "callout.error.background": colors["red.200"],
    "callout.error.border": colors["red.400"],
    "callout.error.icon": colors["red.600"],
    "callout.information.background": colors["blue.200"],
    "callout.information.border": colors["blue.400"],
    "callout.information.icon": colors["blue.600"],
    "callout.neutral.background": colors["grey.200"],
    "callout.neutral.border": colors["grey.400"],
    "callout.neutral.icon": colors["grey.600"],
    "callout.warning.background": colors["yellow.200"],
    "callout.warning.border": colors["yellow.400"],
    "callout.warning.icon": colors["yellow.700"]
  };
export { colorTokens, radiusTokens, spaceTokens };
//# sourceMappingURL=Callout.tokens.mjs.map
